"use strict";
/**
 * The block model.
 *
 * A result card is not one document, it is a fixed set of blocks, each with its
 * own source, its own latency and its own right to fail. The API streams them
 * one at a time (section 4.3) and the web client renders a skeleton per block,
 * so the key list is part of the shared contract rather than an internal
 * detail: both sides must agree on what "all blocks" means.
 *
 * Section 6.1 lists fourteen blocks. Three of them — courts, enforcement and
 * bankruptcy — were removed from the product by decision 4 and must not appear
 * here even as placeholders: a block that exists but is always empty reads as
 * "this company is clean", which is worse than not showing it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCK_KEYS = void 0;
exports.BLOCK_KEYS = [
    'registration',
    'address',
    'activity',
    'founders',
    'management',
    'finance',
    'procurement',
    'risk_registry',
    'debt',
    'relations',
    'contacts',
    'risk_assessment',
];
//# sourceMappingURL=index.js.map